import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { DivisionSalesNetwork } from '../../../models/division.model';
import { DivisionSalesNetworkService } from '../../../services/division-sales-network/divison-sales-network.service';
import { DivisionService } from '../../../services/division/division.service';
import { SalesNetworkService } from '../../../services/sales-network/sales-network.service';

@Component({
  selector: 'app-division-sales-network-form',
  templateUrl: 'division-sales-network-form.component.html',
  styles: ['label.required:after {top: 0}']
})
export class DivisionSalesNetworkFormComponent implements OnInit {
  @Input() divisionSalesNetworkId: number;
  @Input() dialogBoxSalesNetwork: boolean;
  @Output() salesNetworkAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() salesNetworkUpdated: EventEmitter<any> = new EventEmitter<any>();

  public divisionList: Array<{ value: any, label: string }> = sessionStorage.getItem('dsnDivisionList') ? JSON.parse(sessionStorage.getItem('dsnDivisionList')) : [{value: null, label: ''}];
  public salesNetworkList: Array<{ value: any, label: string }> = sessionStorage.getItem('dsnSalesNetworkList') ? JSON.parse(sessionStorage.getItem('dsnSalesNetworkList')) : [{value: null, label: ''}];
  public addEditForm: FormGroup;
  public invalidSubmit: boolean;
  fields: any;

  constructor(
    private fb: FormBuilder,
    private srvDivision: DivisionService,
    private srvSalesNetwork: SalesNetworkService,
    private srvDivisionSalesNetwork: DivisionSalesNetworkService
  ) { }

  ngOnInit(): void {

    this.srvDivisionSalesNetwork.getFields().subscribe(res => {
      this.fields = res;
    });

    const salesObs = !sessionStorage.getItem('dsnSalesNetworkList') ? this.srvSalesNetwork.getAll() : null;
    const divisionObs = !sessionStorage.getItem('dsnDivisionList') ? this.srvDivision.getAll() : null;
    const dsnObs = this.divisionSalesNetworkId !== 0 ? this.srvDivisionSalesNetwork.get(this.divisionSalesNetworkId) : Observable.of(new DivisionSalesNetwork());

    if (divisionObs || salesObs) {
      Observable.zip(salesObs, divisionObs).subscribe(([sales, divisions]) => {

        if (!sessionStorage.getItem('dsnSalesNetworkList')) {
          for (const sale of sales) {
            if (sale.flg_state === '0') {
              this.salesNetworkList.push({
                value: +sale.id,
                label: `(${sale.code}) ${sale.name}`
              });
            }
          }
          sessionStorage.setItem('dsnSalesNetworkList', JSON.stringify(this.salesNetworkList));
        }

        if (!sessionStorage.getItem('dsnDivisionList')) {
          for (const div of divisions) {
            this.divisionList.push({
              value: +div.id,
              label: `(${div.code}) ${div.name}`
            });
          }
          sessionStorage.setItem('dsnDivisionList', JSON.stringify(this.divisionList));
        }

      });
    }

    dsnObs.subscribe(dsn => {
      this.addEditForm = this.fb.group({
        'division_id': new FormControl(dsn.division_id ? +dsn.division_id : null),
        'sales_network_id': new FormControl(dsn.sales_network_id ? +dsn.sales_network_id : null),
      });
    })
  }

  saveOrUpdate(): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    let toSend = new DivisionSalesNetwork();

    toSend.division_id = this.addEditForm.get('division_id').value;
    toSend.sales_network_id = this.addEditForm.get('sales_network_id').value;

    if (this.divisionSalesNetworkId !== 0) {
      toSend.id = this.divisionSalesNetworkId;
      this.srvDivisionSalesNetwork.update(toSend).subscribe(updated => {
        this. salesNetworkAdded.emit(updated);
      });
    } else {
      this.srvDivisionSalesNetwork.create(toSend).subscribe(saved => {
        this.salesNetworkUpdated.emit(saved);
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/division-sales-network/division-sales-network-form.component.ts